import { logEngagement, logEngagementWithDetails } from "../global/log-engagement";

document.addEventListener('DOMContentLoaded', () => {
    initDynamicSearchInputs();
});

$('.js-clear-search').on('click', function () {
    $('.smart-filters__search__textbox').val('');
    $(this).hide();
})

$(document).on('openSmartFilters', function(e) {
    $.modal({
        open: 'smart-filters',
        type: 'full',
        triggerOpen: true,
        onComplete: (function() {
            let init = false;

            return function() {
                if (init) {
                    return;
                }
                initStickyCloseButtonObserver();
                init = true;
            }
        })(),
        onClose: function() {
            const $form = $('#smart-filters-form');
            const fieldsetId = $form.data('fieldsetId');
            if (fieldsetId) {
                const $fieldset = $(`#${fieldsetId}`);
                const originalIndex = $fieldset.data('index');
                if (originalIndex) {
                    $('fieldset', $form).eq(originalIndex - 1).after($fieldset);
                }
            }
            $form.data('fieldsetId', '');
        },
    })
});

$(function() {
    $('.js-smart-filter-question').on('click', function(){
        const $this = $(this);
        const fieldsetId = $this.data('fieldsetId');
        $('#smart-filters-form').data('fieldsetId', fieldsetId).prepend($(`#${fieldsetId}`));
        $(document).trigger('openSmartFilters');
        logEngagementWithDetails(window.location.href, 'smart_filter_pill', 'click', $this.data('category'));
    });
});

function initStickyCloseButtonObserver() {
    const trigger = document.querySelector('.js-sticky-trigger');
    const topFixed = document.querySelector('.js-top-fixed');
    const closeButton = topFixed?.querySelector('.js-modal-close');

    if (!trigger || !topFixed || !closeButton) return;

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) {
                topFixed.classList.add('smart-filters__top-button--fixed');
                closeButton.classList.remove('u-margin-b--xl');
            } else {
                topFixed.classList.remove('smart-filters__top-button--fixed');
                closeButton.classList.add('u-margin-b--xl');
            }
        },
        { root: null, threshold: 0 }
    );

    observer.observe(trigger);
}

function initDynamicSearchInputs() {
    const inputs = document.querySelectorAll('input.smart-filters__search__textbox');

    inputs.forEach(input => {
        if (input.dataset.dynamicBound) return;

        input.dataset.dynamicBound = 'true';
        const wrapper = input.closest('.smart-filters__search');

        input.addEventListener('focus', function handleFocus(event) {
            const originalInput = event.target;
            const wrapper = originalInput.closest('.smart-filters__search');
            const originalHeight = originalInput.offsetHeight;
            const iconSpan = wrapper.querySelector('span');
            const iconPaddingTop = iconSpan
                ? Math.max(0, (originalHeight - iconSpan.offsetHeight) / 2)
                : 0;

            // Create a wrapper for textarea + clear button
            const container = document.createElement('div');
            container.style.position = 'relative';
            container.style.flex = '1';
            container.style.minWidth = '0';

            // Create textarea
            const textarea = document.createElement('textarea');
            textarea.className = originalInput.className;
            textarea.name = originalInput.name;
            textarea.value = originalInput.value;
            textarea.placeholder = originalInput.placeholder;
            textarea.setAttribute('rows', '1');
            textarea.style.overflow = 'hidden';
            textarea.style.whiteSpace = 'normal';
            textarea.style.boxSizing = 'border-box';
            textarea.style.width = '100%';
            textarea.style.paddingRight = '2.5rem'; // Make space for the button
            textarea.style.height = originalHeight + 'px';

            // Create clear button
            const clearBtn = document.createElement('button');
            clearBtn.setAttribute('type', 'button');
            clearBtn.className = 'smart-filters__clear-search';
            clearBtn.innerHTML = '&times;';
            clearBtn.style.position = 'absolute';
            clearBtn.style.right = '0.6rem';
            clearBtn.style.top = (originalHeight / 2) + 'px';
            clearBtn.style.transform = 'translateY(-50%)';
            clearBtn.style.background = 'transparent';
            clearBtn.style.border = 'none';
            clearBtn.style.fontSize = '1.5rem';
            clearBtn.style.color = '#333';
            clearBtn.style.cursor = 'pointer';
            clearBtn.style.lineHeight = '1';
            clearBtn.style.padding = '0';

            clearBtn.addEventListener('mousedown', (e) => {
                // Prevent textarea from losing focus before click logic runs
                e.preventDefault();
            });

            clearBtn.addEventListener('click', (e) => {
                e.preventDefault();
                textarea.value = '';
                textarea.style.height = 'auto';
                textarea.style.height = Math.max(textarea.scrollHeight, originalHeight) + 'px';
                textarea.focus(); // re-focus to keep textarea active
            });


            container.appendChild(textarea);
            container.appendChild(clearBtn);
            wrapper.replaceChild(container, originalInput);

            // Switch to top-aligned layout so icons stay pinned to the first line of
            // text as the textarea grows beyond a single line
            wrapper.style.alignItems = 'flex-start';
            if (iconSpan) iconSpan.style.paddingTop = iconPaddingTop + 'px';

            textarea.focus();

            // Handle pre-filled content that may require more than one line
            requestAnimationFrame(() => {
                textarea.style.height = 'auto';
                textarea.style.height = Math.max(textarea.scrollHeight, originalHeight) + 'px';
            });

            textarea.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    textarea.closest('form').requestSubmit();
                }
            });

            textarea.addEventListener('input', () => {
                textarea.style.height = 'auto';
                textarea.style.height = Math.max(textarea.scrollHeight, originalHeight) + 'px';
            });

            textarea.addEventListener('blur', () => {
                wrapper.style.alignItems = '';
                if (iconSpan) iconSpan.style.paddingTop = '';

                const newInput = document.createElement('input');
                newInput.type = 'text';
                newInput.className = textarea.className;
                newInput.name = textarea.name;
                newInput.value = textarea.value;
                newInput.placeholder = textarea.placeholder;
                newInput.dataset.dynamicBound = 'true';

                wrapper.replaceChild(newInput, container);
                newInput.addEventListener('focus', handleFocus);
            });
        });
    });
}


// WEBPACK FOOTER //
// ./src/scripts/modules/abtest/smart-filters.js